export default "__VITE_ASSET__Dwuh1Zog__"